$shm_projects_task $mol_book2
	project_id \
	task_id \
	pages <= task_pages /
	Details_page $mol_page
		title <= task_page_title \Задача
		body <= task_body /
	Editor $mol_view
		sub /
			<= Title_field $mol_form_field
				name \Название
				Content <= Task_title $mol_string
					value? <=> task_title_draft? \
			<= Assignee_field $mol_form_field
				name \Исполнитель
				Content <= Assignee $mol_select
					value? <=> assignee_id_draft? \
					dictionary <= assignee_options *
			<= Priority_field $mol_form_field
				name \Приоритет
				Content <= Priority $mol_select
					value? <=> priority_draft? \normal
					dictionary <= priority_options *
			<= Description_field $mol_form_field
				name \Описание задачи
				Content <= Description_draft $mol_textarea
					value? <=> description_draft? \
			<= Editor_actions $mol_view
				sub <= editor_action_rows /
	Research $mol_button_minor
		title \Исследовать без внесения изменений
		enabled <= task_action_enabled true
		click? <=> research? null
	Work $mol_button_minor
		title \Выполнить работу без пререлиза
		enabled <= task_action_enabled
		click? <=> work? null
	Work_prerelease $mol_button_minor
		title \Выполнить работу и сделать пререлиз
		enabled <= task_action_enabled
		click? <=> work_prerelease? null
	Edit_cancel $mol_button_minor
		title \Отмена
		click? <=> edit_cancel? null
	Summary $mol_view
		sub <= summary_rows /
	Task_meta $mol_view
		sub /
			<= Priority_meta $mol_form_field
				name \Приоритет
				Content <= Priority_meta_text $mol_text
					text <= priority_meta \
	Description_card $mol_form_field
		name \Описание задачи
		Content <= Description_text $mol_text
			text <= task_description \
	Result_card $mol_view
		sub /
			<= Result_title $mol_view
				sub / \Результаты
			<= Result_text $shm_agent_message_text
				text <= task_result \
	Summary_actions $mol_view
		sub <= summary_action_rows /
	Edit_open $mol_button_minor
		title \Редактировать
		click? <=> edit_open? null
	Agent $shm_projects_task_chat
		run <= run_data? null
		iteration <= task_iteration 0
		version <= project_version \
		workspace_id <= workspace_id \base
		prompt? <=> message_draft? \
		send? <=> send_message? null
		after <= agent_after /
